<template>
  <form @submit.prevent="submit">
    <ZDialog :show="isVisible">
      <template #header>
        <div>
          <h4 class="modal-title">
            Confirm Delete
          </h4>
        </div>
      </template>
      <template #body>
        <div>
          <div class="row">
            <div class="form-group col-md-12">
              <p>Are you sure you wish to Delete this {{ tag }}?</p>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="submit" class="btn btn-primary ms-1">Delete</button>
        </div>
      </template>
    </ZDialog>
  </form>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'confirm-delete',
  components: {
    ZDialog
  },
  props: {
    value: {
      type: Boolean
    },
    tag: String
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    submit() {
      this.$emit('delete')
    }
  }
}
</script>
